<!------------------------------

      Page Actions

------------------------------->

<div *sbPageAction>

</div>

<!------------------------------

    Table wrapper

------------------------------->

<sb-table-wrapper headline="{{'nav.network.bookings' | translate}}" [itemsData]="bookings" [isInModalContext]="isInModalContext"
                  (filterChange)="requestDebounced()" [options]="options" (optionsChange)="requestDebounced($event)"
                  [loading]="loading" [itemName]="'bookings'" [showExactMatch]="true">

    <!------------------------------

        Header More

    ------------------------------->

    <div header-more>
        <div class="d-flex justify-content-end align-items-center w-100 mb-3">
            <div container="body"
                 [ngbTooltip]="(bookingService.countDeprecatedBookings(bookings) === 0 && !showDeprecatedBookings) ? noDeprecatedBookings() : null"
                 class="d-flex">
                {{'lang.requirementBookingAssignment.showDeprecated' | translate}}
                <div class="form-check form-switch ml-3">
                    <input
                            type="checkbox" role="switch" class="form-check-input" [id]='"customSwitchShowDeprecated"'
                            [(ngModel)]="showDeprecatedBookings" (ngModelChange)="requestDebounced()">
                    <label class="form-check-label" [for]='"customSwitchShowDeprecated"'></label>
                </div>
            </div>
            <div container="body"
                 [ngbTooltip]="(bookingService.countExcludedBookings(bookings) === 0 && !showExcludedBookings) ? noExcludedBookings() : null"
                 placement="top" class="d-flex mr-3">
                {{'lang.requirementBookingAssignment.showExcluded' | translate}}
                <div class="form-check form-switch ml-3">
                    <input
                            type="checkbox" role="switch" class="form-check-input" [id]='"customSwitchShowExcluded"'
                            [(ngModel)]="showExcludedBookings" (ngModelChange)="requestDebounced()">
                    <label class="form-check-label" [for]='"customSwitchShowExcluded"'></label>
                </div>
            </div>
          <sb-comp-dropdown-select (msOptionsChange)="msRequest('CONTENT_CULLS', $event)"
                                   (selectedDataEmitter)="update($event, 'CONTENT_CULLS')"
                                   *ngPermissions="permissionService.Permission.cull_list"
                                   [disabled]="loading"
                                   [dropDownDatatype]="'CONTENT_CULLS'" [inputData]="contentCulls"
                                   [msOptions]="msContentCullOptions" [selectedInputData]="filteredContentCulls ? filteredContentCulls : []"
                                   [showColumnIcon]="false" [showSubmit]="true">
          </sb-comp-dropdown-select>

            <sb-comp-dropdown-select
                    [inputData]="companies" [dropDownDatatype]="'COMPANIES'"
                    (selectedDataEmitter)="update($event, 'COMPANIES')" [showColumnIcon]="false"
                    [msOptions]="msCompanyOptions" (msOptionsChange)="msRequest('COMPANIES', $event)"
                    [selectedInputData]="selectedCompanies">
            </sb-comp-dropdown-select>
        </div>
    </div>


    <!------------------------------

          Table Header

    ------------------------------->
    <ng-template #thead>

        <tr>
            <th *ngIf="!isInModalContext">{{'lang.globals.finished' | translate}}</th>
          <th class="table--sortable" (click)="setToOrder('ID')"
              [ngClass]="{'table--sorted': orderOption?.value==='ID'}">
                {{'lang.globals.id' | translate}}
            @if (orderOption.value === 'Id') {
                <sb-icon
                    *ngIf="orderOption.direction === 'desc'"
                    icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
                <sb-icon
                    *ngIf="orderOption.direction !== 'desc'"
                    icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
            } @else {
              <sb-icon
                  icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
            }
            </th>
            <th *ngIf="!isInModalContext">{{'lang.globals.status' | translate}}</th>
          <th class="table--sortable" (click)="setToOrder('Medium')"
              [ngClass]="{'table--sorted': orderOption?.value==='Medium'}">
                {{'lang.requirementBookingAssignment.selectedMotive' | translate}}
            @if (orderOption.value === 'Medium') {
                <sb-icon
                    *ngIf="orderOption.direction === 'desc'"
                    icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
                <sb-icon
                    *ngIf="orderOption.direction !== 'desc'"
                    icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
            } @else {
              <sb-icon
                  icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
            }
            </th>
          <th *ngIf="!isInModalContext" class="table--sortable"
              (click)="setToOrder('Advertiser')"
              [ngClass]="{'table--sorted': orderOption?.value==='Advertiser'}">
                {{'lang.verification.advertiser' | translate}}
            @if (orderOption.value === 'Advertiser') {
                <sb-icon
                    *ngIf="orderOption.direction === 'desc'"
                    icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
                <sb-icon
                    *ngIf="orderOption.direction !== 'desc'"
                    icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
            } @else {
              <sb-icon
                  icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
            }
            </th>
            <th>
                {{'lang.globals.customer' | translate}}
            </th>
          <th *ngIf="!isInModalContext" class="table--sortable" (click)="setToOrder('Channel')"
              [ngClass]="{'table--sorted': orderOption?.value==='Channel'}">
                {{'lang.globals.channel' | translate}}
            @if (orderOption.value === 'Channel') {
                <sb-icon
                    *ngIf="orderOption.direction === 'desc'"
                    icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
                <sb-icon
                    *ngIf="orderOption.direction !== 'desc'"
                    icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
            } @else {
              <sb-icon
                  icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
            }
            </th>
            <th>{{'lang.requirementBookingAssignment.marker' | translate}}</th>
            <th>{{'lang.globals.resolution' | translate}}</th>
            <!--<th *ngPermissions="permissionService.Permission.ds_cm_reporting">
              {{'lang.globals.playoutPulse' | translate}}
            </th> -->
            <th *ngIf="isInModalContext" class="tr"></th>
        </tr>
    </ng-template>
    <!------------------------------

      Table Body

  ------------------------------->
    <ng-template #tbody let-booking>

        <tr>
            <td *ngIf="!isInModalContext">
                <sb-icon *ngIf="booking?.finished" class="cursor-help green" icon="success" [ngbTooltip]="'true'"
                         container="body"></sb-icon>
                <sb-icon *ngIf="!booking?.finished" class="cursor-help red" icon="error" [ngbTooltip]="'false'"
                         container="body"></sb-icon>
            </td>
            <td>
                {{booking?.id}}
            </td>
            <td *ngIf="!isInModalContext">
                <sb-comp-booking-status [booking]="booking"></sb-comp-booking-status>
            </td>
            <td>
                <sb-comp-image-name-wrapper [medium]="booking?.medium" [thumbnailSize]="'S'" [still]="true">
                    <span firstLine class="font-size-lg" [innerHTML]="booking?.medium?.name | truncate : 45"></span>
                    <span secondLine class="text-muted font-weight-bold"
                          [innerHTML]="booking?.medium?.mediumGroup?.name | truncate : 45"></span>
                </sb-comp-image-name-wrapper>
            </td>
            <td *ngIf="!isInModalContext">
                <sb-comp-image-name-wrapper [image]="booking?.advertiser?.primaryCompany?.logo?.url">
                    <span firstLine [innerHTML]="booking?.advertiser?.name | truncate : 35"></span>
                </sb-comp-image-name-wrapper>
            </td>
            <td>
                {{booking?.customer?.name}}
            </td>
            <td *ngIf="!isInModalContext">
                <sb-comp-link
                        [classes]="'font-size-lg'"
                        [title]="booking?.channel?.name | truncate:30"
                        [permission]="permissionService.Permission.channel_show"
                        [link]="util.RoutingID.channelDetailsOverview"
                        [pathParams]="[{id: 'channelID', value: booking?.channel?.id}]">
                </sb-comp-link>
                <p class="m-0 text-muted font-weight-bold" [innerHTML]="booking?.channel?.description | truncate: 45"></p>
            </td>
            <td>
                {{booking?.marker?.name}}
            </td>
            <td>
                <span>{{booking?.marker?.resolution?.id}}</span>
            </td>
            <!--<td *ngIf="permissionService.hasPermission(permissionService.Permission.ds_cm_reporting)" class="d-xxxl-table-cell d-none">
              <sb-line-small-chart *ngIf="booking?.reporting?.loadingDone" [chartData]="booking.reporting">
              </sb-line-small-chart>
            </td>-->
            <td *ngIf="isInModalContext">
                <button (click)="toggleBookingSelection(booking)"
                        class="btn btn-primary">
                    <sb-icon *ngIf="isInSelectedBookings(booking)" icon="boxChecked"></sb-icon>
                    <sb-icon *ngIf="!isInSelectedBookings(booking)" icon="box"></sb-icon>
                </button>
            </td>
        </tr>
    </ng-template>

    <!------------------------------

     Card Element

  ------------------------------->

    <!-- no card element -->

    <div footer-more *ngIf="isInModalContext" class="d-flex justify-content-between">
        <div class="ml-3 d-flex align-items-center">
            {{selectedBookings?.length}} {{'lang.globals.bookings' | translate}}
        </div>
        <div class="ml-2">
            <sb-button (click)="deselectBookings()"
                       classes="btn-danger btn-sm" [type]="'button'">{{'lang.globals.deselectAll' | translate}}
            </sb-button>
            <sb-button (click)="returnSelectedBookings()" [disabled]="selectedBookings?.length < 1"
                       classes="btn-primary btn-sm" [type]="'button'">{{'lang.globals.submit' | translate}}
            </sb-button>
        </div>
    </div>
</sb-table-wrapper>
